import StaticData from "./static-data";

export class BatchDownloadUtils {

    /**
     * Saves the current date as timestamp in the session storage associated with the provided key
     *
     * @param key Key used to store the timestamp in the session storage.
     */
    public static saveTimestamp(key: string): void{
        sessionStorage.setItem(key, new Date().getTime().toString());
    }

    /**
     * Retrieves a timestamp from the session storage using the provided key
     *
     * @param key Key used to retrieve the timestamp from the session storage.
     * @return The timestamp value stored in the session storage associated to the provided key, otherwise returns -1
     */
    public static getTimestamp(key: string): number{
        const timeStampString = sessionStorage.getItem(key);
        return timeStampString ? Number(timeStampString) : -1;
    }

    /**
     * Checks if the provided timestamp is older than five minutes from the current time.
     *
     * @param batchDownloadTimeStamp Timestamp which should be checked
     * @return True if the provided timestamp is older than five minutes, otherwise false
     */
    public static isTimeStampOlderThanFiveMinutes(batchDownloadTimeStamp: number): boolean{
        const currentTimeStamp = new Date().getTime();
        return (currentTimeStamp - batchDownloadTimeStamp) > StaticData.FIVE_MINUTES_IN_MS;
    }
}
